import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let selectedSlotInterval = useDataValue({
    context: 'tab',
    path: 'selected.slot_interval',
    viewPath: props.viewPath,
  })
  let isScheduling = useDataValue({
    context: 'tab',
    path: 'appointment_overlay.open',
    viewPath: props.viewPath,
  })
  let submitSettings = useDataSubmit({
    context: 'settings',
    viewPath: props.viewPath,
  })
  let submitTab = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (typeof props.id !== 'number' || selectedSlotInterval === props.id)
      return

    if (isScheduling) {
      return submitTab({
        type: 'scheduling/setSlotInterval',
        slot_interval: props.id,
      })
    }

    return submitSettings({
      key: 'slot_interval',
      value: props.id,
    })
  }
}
